import React, { useEffect, useId, useMemo } from "react";

const optionLabel = (index) => String.fromCharCode(65 + index);

const StudentMcqResponse = ({ question, value = "", disabled = false, onChange }) => {
  const groupId = useId();
  const optionIds = useMemo(
    () => new Set(question.options.map((option) => option.id)),
    [question.options]
  );
  const selectedOptionId = optionIds.has(value) ? value : "";

  useEffect(() => {
    if (value && !optionIds.has(value)) {
      console.warn(
        `[ENTER QUIZ] Stored answer for question "${question.id}" does not match a visible option.`
      );
    }
  }, [optionIds, question.id, value]);

  return (
    <fieldset className="eq-mcq-response" disabled={disabled}>
      <legend className="eq-sr-only">Choose one answer for question {question.id}</legend>
      {question.options.map((option, index) => {
        const selected = selectedOptionId === option.id;
        const inputId = `${groupId}-option-${index}`;
        return (
          <label
            className={`eq-mcq-option${selected ? " is-selected" : ""}${disabled ? " is-disabled" : ""}`}
            htmlFor={inputId}
            key={option.id}
          >
            <input
              checked={selected}
              className="eq-mcq-radio"
              id={inputId}
              name={`${groupId}-question`}
              onChange={() => onChange(option.id)}
              type="radio"
              value={option.id}
            />
            <span className="eq-mcq-option-label" aria-hidden="true">{optionLabel(index)}</span>
            <span className="eq-mcq-option-text">{option.text}</span>
          </label>
        );
      })}
    </fieldset>
  );
};

export default StudentMcqResponse;
